import { Ng2StateDeclaration } from '@uirouter/angular';
import { PasswordChangeFeatureComponent } from './password-change-feature/password-change-feature.component';

export const PasswordChangeRoute: Ng2StateDeclaration = {
    name: 'passwordchange',
    url: '/passwordchange',
    data: { requiresAuth: true },

    component: PasswordChangeFeatureComponent
};
